<template>
  <Sheet>
    <div
      class="px-5 pt-2 pb-3 text-[16px] font-medium leading-[20px] text-gray-800"
    >
      Sort by
    </div>
    <div class="h-px w-full shrink-0 bg-[#efefef]" />

    <Sheet.Body class="px-0!">
      <div
        v-for="option in options"
        :key="option.value"
        class="flex h-[44px] cursor-pointer items-center justify-between px-5"
        @click="select(option.value)"
      >
        <span class="text-[16px] leading-[20px] text-gray-800">
          {{ option.label }}
        </span>
        <Radio
          :value="option.value"
          :model-value="selected"
          class="pointer-events-none"
        />
      </div>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Sheet, Radio, useSheet } from '@dacr/library'
import { SearchSort } from '@/shared/graphql/legacy/generated'

const props = defineProps<{
  initialState: SearchSort
  onChange: (value: SearchSort) => void
}>()

const { close } = useSheet()

const options = [
  { label: 'Name (A-Z)', value: SearchSort.NameAsc },
  { label: 'Name (Z-A)', value: SearchSort.NameDesc },
  { label: 'Timestamp (Oldest)', value: SearchSort.TimestampAsc },
  { label: 'Timestamp (Newest)', value: SearchSort.TimestampDesc },
]

const selected = ref<SearchSort>(props.initialState)

const select = (value: SearchSort) => {
  selected.value = value
  props.onChange(value)
  close()
}
</script>
